import { Box, FormControl, OutlinedInput } from "@mui/material";
import React, { useEffect, useState } from "react";

// Define os tipos das props
interface CodeProps {
  onChange: (codigo: string[]) => void; // Função chamada ao alterar o código
}

const Code: React.FC<CodeProps> = ({ onChange }) => {
  const [codigo, setCodigo] = useState<string[]>(["", "", "", "", "", ""]); // Inicializa um array de 6 strings vazias

  useEffect(() => {
    onChange(codigo); // Chama a função onChange sempre que o código é alterado
  }, [codigo, onChange]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    i: number
  ) => {
    const value = e.target.value.replace(/\D/g, "").slice(-1); // Permite apenas um número
    const newCodigo = [...codigo];
    newCodigo[i] = value;
    setCodigo(newCodigo);

    // Move o foco para o próximo campo, se possível
    if (i < 5 && value) {
      const nextElement = document.getElementById(`${i + 1}_code`);
      if (nextElement) {
        (nextElement as HTMLInputElement).focus();
      }
    }
  };

  const handlePaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    i: number
  ) => {
    e.preventDefault();
    const target = e.target as HTMLInputElement; // Explicitly cast the target
    const pastedText = e.clipboardData.getData("text/plain").replace(/\D/g, ""); // Remove caracteres não numéricos
    const array = Array(6)
      .fill("")
      .map((_, j) => pastedText[j] || ""); // Preenche o array com os valores colados
    setCodigo(array);
  };

  const elementos = [];
  for (let i = 0; i < 6; i++) {
    elementos.push(
      <FormControl
        key={`${i}_form_code`}
        sx={{ width: "15%" }}
        variant="outlined"
      >
        <OutlinedInput
          autoComplete="off"
          id={`${i}_code`}
          inputProps={{
            maxLength: 1,
            "aria-label": "weight",
          }}
          type="text"
          value={codigo[i]}
          aria-describedby="outlined-weight-helper-text"
          onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
            handlePaste(e, i)
          }
          onChange={(e) => handleInputChange(e, i)} // Passa uma função de retorno de chamada
        />
      </FormControl>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        direction: "row",
        justifyContent: "space-between",
        width: "90%",
      }}
    >
      {elementos}
    </Box>
  );
};

export default Code;
